module.exports = __webpack_public_path__ + "static/media/admission.b9990303.png";